import { Box, Button, Spinner, Text, VStack } from '@chakra-ui/react'
import { CopyNoteIcon } from '@icons'
import React, { useState } from 'react'
import SendEmailTab from './send-email-tab'
import { SocialSharingModule } from './social-sharing-module'

interface SendInvitesTabProps {
  handleCopyClick: () => void
  referralLink: string
  hasCopied: boolean
  isFetchingLink: boolean
}

export const SendInvitesTab: React.FC<SendInvitesTabProps> = ({
  handleCopyClick,
  referralLink,
  hasCopied,
  isFetchingLink
}) => {
  const [showEmailSendScreen, setShowEmailSendScreen] = useState(false)

  const handleEmailOption = () => {
    setShowEmailSendScreen(true)
  }

  const handleEmailCancel = () => {
    setShowEmailSendScreen(false)
  }

  if (showEmailSendScreen) {
    return <SendEmailTab onCancel={handleEmailCancel} />
  }

  return (
    <Box p={4}>
      <VStack spacing={6} align="stretch" justifyContent="center">
        <Box textAlign="center">
          <Text fontSize="24px" fontWeight="bold">
            Share your 💙 of Blueprint
          </Text>
          <Text mt={2}>
            Refer fellow clinicians and we'll pay your bill for <br />
            <Text as="span" fontWeight="bold">
              {' '}
              months, years or even forever!
            </Text>
          </Text>
        </Box>

        <VStack justifyContent="center">
          <Text textAlign="center" mb={2}>
            Copy the unique code and share:
          </Text>
          <Button
            onClick={handleCopyClick}
            isFullWidth={true}
            maxWidth="300px"
            height="50px"
            colorScheme="blue"
            leftIcon={isFetchingLink ? <Spinner size="sm" /> : <CopyNoteIcon />}
            isLoading={isFetchingLink}
          >
            {hasCopied ? 'Copied!' : 'Copy link'}
          </Button>
        </VStack>

        <SocialSharingModule
          referralURL={referralLink}
          handleCopyLink={handleCopyClick}
          handleEmailOption={handleEmailOption}
        />
      </VStack>
    </Box>
  )
}

export default SendInvitesTab
